import theme from 'src/theme';

export const DATE_FILTER_LIST = [
  { id: '7', name: '7 Days' },
  { id: '15', name: '15 Days' },
  { id: '30', name: '30 Days' },
  { id: '60', name: '60 Days' },
];

export const chartOptions = {
  animation: true,
  responsive: true,
  cornerRadius: 20,
  layout: { padding: 0 },
  legend: { display: false },
  maintainAspectRatio: false,
  tooltips: {
    backgroundColor: theme.palette.background.paper,
    bodyFontColor: theme.palette.text.secondary,
    borderColor: theme.palette.divider,
    borderWidth: 1,
    enabled: true,
    footerFontColor: theme.palette.text.secondary,
    intersect: false,
    mode: 'index',
    titleFontColor: theme.palette.text.secondary
  }
};
